<template>
  <div class="left_content bsb">
    <div class="sidebar">
      <div class="sidebar_item "
           v-for="(item,ind) in list"
           :key="ind">
        <div class="sidebar_item_title flex aic jcb "
             @click="showChildren(item)"
             @mouseover="isMou = item.id"
             @mouseout="isMou = ''">
          <span class="sidebar_item_title_text"
                :class="{active: isShow === item.id}">{{item.name}}</span>
          <span class="footer_icon left_arrow"
                :class="{
                  down_arrow_active:isShow === item.id,
                  left_arrow_active:isMou === item.id}"></span>
        </div>
        <div class="sidebar_item_child flex aic "
             :class="{active: isChild === child.id}"
             v-show="item.show"
             v-for="(child,index) in item.helpLst"
             :key="index"
             @click="changeChild(child)">
          {{child.title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from '@/mixins/mixins';
import { mapMutations } from "vuex";
export default {
  name: "ViewLeft",
  mixins: [Mixins.MakeRoute(['id'], )],
  computed: {

  },
  watch: {
    $route () {
      let type = this.$route.query.id;
      this.list.forEach(e => {
        e.helpLst.forEach(v => {
          if (v.id === type) {
            this.isShow = e.id;
            this.isChild = v.id;
            e.show = true;
          }
        })
      })
    }
  },
  data () {
    return {
      list: [
        // {
        //   id: 1,
        //   title: '会员相关',
        //   show: false,
        //   children: []
        // },
      ],
      isShow: '', // 显示的一级目录
      isChild: '', // 显示的二级目录
      isMou: '', // 控制hover
      type: ''
    };
  },
  methods: {
    ...mapMutations(['setHelpId']),
    showChildren (item) {
      let val = this.list.find(e => e.id === item.id);
      if (this.isShow === item.id) {
        this.list.find(e => e.id === item.id).show = !val.show;
        this.isShow = '';
        this.isChild = '';
      } else {
        this.isShow = item.id;
        this.list.forEach(e => {
          e.show = this.isShow === e.id;
        });
        //子级
        if (val.helpLst.length) {
          this.isChild = val.helpLst[0].id;
          this.$router.replace({
            path: '/help/core',
            query: { id: this.isChild  }
          });
        }
      }
    },
    changeChild (item) {
      this.$router.replace({
        path: '/help/core',
        query: { id: item.id }
      });
      this.isChild = item.id;
    },
    getCatalogue () {
      this.http.NEWGetCatalogue().then(res => {
				if(res instanceof Array){
					this.list = [...res];
				}else if(res instanceof Object){
					for(let i in res){
						this.list.push(res[i])
					}
				}
				this.list.forEach(val => Object.assign(val, { show: false }));
				let { type } = this;
				type = this.$route.query.id ? +this.$route.query.id :  this.list[0].helpLst[0].id;
				this.id = type;
				this.setHelpId(type);
				if (type) {
					this.list.forEach(e => {
						e.helpLst.forEach(val => {
							if (val.id === type) {
								this.isChild = val.id;
								this.isShow = e.id;
								e.show = !e.show;
							}
						})
					})
				}					
				
      }).catch(this.$err);
    }
  },
  created () {
    this.getCatalogue();
  }
}
</script>

<style scoped lang="less">
@import '../../assets/less/function';
.left_content {
  padding: 36px 20px;
  width: 287px;
  height: 639px;
  background: #fff;
  border-radius: 8px;
}

.footer_icon {
  .spirit(url(../../assets/images/footer/footer_icon.png));
  &.left_arrow {
    &:after {
      width: 8px;
      height: 13px;
      background-position: -61px -3px;
    }
  }
  &.left_arrow_active {
    &:after {
      width: 8px;
      height: 13px;
      background-position: -72px -3px;
    }
  }
  &.down_arrow_active {
    &:after {
      width: 13px;
      height: 8px;
      background-position: -86px -6px;
    }
  }
}

.sidebar {
  color: #959595;
  .sidebar_item {
    width: 247px;
    // background-color: pink;
    .sidebar_item_title {
      font-size: 16px;
      height: 44px;
      &:hover {
        color: #1177ff;
        cursor: pointer;
      }
    }
    .sidebar_item_child {
      width: 247px;
      // height: 44px;
			line-height: 20px;
      padding:12px 0 12px 16px;
      font-size: 14px;
      &:hover {
        color: #1177ff;
        cursor: pointer;
      }
      // background-color: skyblue;
    }
  }
}

.active {
  color: #1177ff;
}
</style>